export default "__VITE_ASSET___nfKCq31__"